import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
import "src/services/styles/sweetAlert.css";
const categorias = new datos("categorias");

/**
 * Llama a estadisticasUpdateContador para registrar una consulta o descarga.
 * Valida el límite en el backend ANTES de permitir la acción.
 *
 * @param {'consultas'|'descargas'|'busquedas'} proceso
 * @returns {{ permitido: boolean, message: string, estadisticas: object|null }}
 */
export const actualizarContadorEstadisticas = async (proceso) => {
  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_usuario = user_data?.id;

  if (!id_usuario) {
    return { permitido: false, message: "No se pudo determinar el usuario" };
  }

  try {
    const svc = new datos("estadisticas_procesos");
    const response = await svc.estadisticasUpdateContador({
      proceso,
      id_usuario: `${id_usuario}`,
    });

    const ok = response?.status === "true" || response?.status === true;

    if (ok) {
      return { permitido: true, message: "", estadisticas: response?.wsResponse ?? null };
    }

    return {
      permitido: false,
      message: response?.message || "Límite de " + proceso + " excedido",
    };
  } catch (e) {
    return { permitido: false, message: "Error al verificar estadísticas" };
  }
};

export const getEstadisticas= async (auth) => {
  categorias.addCondition("estadisticas_procesos", "id", 0, ">");
  const response = await categorias.get();
  return esArray(response.wsResponse.estadisticas_procesos);
};

export const getCategoriasPaginated = async (limit, offset) => {
  categorias.addCondition("categorias", "id", 0, ">");
  categorias.addLimitCondition(limit, offset);
  const response = await categorias.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: esArray(response.wsResponse.categorias),
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const getEstadisticasPaginated = async (limit, offset, filters = {}) => {
  // Servicio
  const estadisticas = new datos("estadisticas_procesos");

  const payload = {
    limit: `${limit}`,
    offset: `${offset}`,
    ...filters,
  };

  const response = await estadisticas.estadisticasGet(payload);

  let result = {
    data: [],
    total_records: 0,
    limites: null,
  };

  if (
    response &&
    response.wsResponse &&
    response.wsResponse.estadisticas
  ) {
    const ws = response.wsResponse.estadisticas;

    // ===============================
    // LISTADO
    // ===============================
    let listado = [];

    if (ws.listado && ws.listado.estadisticas_procesos) {
      listado = esArray(ws.listado.estadisticas_procesos);
    }

    // Total
    let total = 0;
    if (ws.listado && ws.listado.total !== undefined) {
      total = parseInt(ws.listado.total, 10);
    } else {
      total = listado.length;
    }

    // ===============================
    // LIMITES
    // ===============================
    let limites = null;

    if (ws.limites) {
      const parseLimite = (n) => {
        const v = parseInt(n, 10);
        return isNaN(v) ? 0 : v;
      };

      limites = {
        consultas: ws.limites.consultas
          ? {
              permitido: parseLimite(ws.limites.consultas.permitido),
              usado: parseLimite(ws.limites.consultas.usado),
              restante: parseLimite(ws.limites.consultas.restante),
              ilimitado: parseLimite(ws.limites.consultas.restante) < 0,
            }
          : null,

        busquedas: ws.limites.busquedas
          ? {
              permitido: parseLimite(ws.limites.busquedas.permitido),
              usado: parseLimite(ws.limites.busquedas.usado),
              restante: parseLimite(ws.limites.busquedas.restante),
              ilimitado: parseLimite(ws.limites.busquedas.restante) < 0,
            }
          : null,

        descargas: ws.limites.descargas
          ? {
              permitido: parseLimite(ws.limites.descargas.permitido),
              usado: parseLimite(ws.limites.descargas.usado),
              restante: parseLimite(ws.limites.descargas.restante),
              ilimitado: parseLimite(ws.limites.descargas.restante) < 0,
            }
          : null,
      };
    }

    result = {
      data: listado,
      total_records: total,
      limites: limites,
    };

    console.log("result estadisticas", result);
  }

  return result;
};


